import { consentStorage } from './storage'

interface ConsentControlledVendorOptions<TConfiguration> {
  scriptAttribute: string
  resolveConfiguration: () => TConfiguration | undefined
  isQueueAvailable: () => boolean
  createQueue: () => void
  grantConsent: () => void
  revokeConsent: () => void
  initialize: (configuration: TConfiguration) => void
  resolveScriptUrl: (configuration: TConfiguration) => string
}

export function readConfiguredValue(value: string | undefined) {
  return value?.trim() || undefined
}

export function createConsentControlledVendor<TConfiguration>(
  options: ConsentControlledVendorOptions<TConfiguration>
) {
  let initialized = false
  let consentGranted = false

  function loadScript(configuration: TConfiguration) {
    if (document.querySelector(`script[${options.scriptAttribute}]`)) return

    const script = document.createElement('script')
    script.async = true
    script.src = options.resolveScriptUrl(configuration)
    script.setAttribute(options.scriptAttribute, '')
    document.head.appendChild(script)
  }

  function configure() {
    if (consentStorage.getConsent() !== 'granted') return false

    const configuration = options.resolveConfiguration()
    if (!configuration) return false

    if (!options.isQueueAvailable()) options.createQueue()

    if (!consentGranted) {
      options.grantConsent()
      consentGranted = true
    }

    if (!initialized) {
      options.initialize(configuration)
      initialized = true
    }

    loadScript(configuration)
    return true
  }

  function revokeConsent() {
    if (options.isQueueAvailable()) options.revokeConsent()
    consentGranted = false
  }

  return { configure, revokeConsent }
}
